import { render, staticRenderFns } from "./RecentRelease.vue?vue&type=template&id=b5c1fd44&"
import script from "./RecentRelease.vue?vue&type=script&lang=js&"
export * from "./RecentRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports